// extracted by mini-css-extract-plugin
export default {"contentWrapper":"promo-page-starting-popup__contentWrapper___eFSdP","title":"promo-page-starting-popup__title___zGAXv","closeButton":"promo-page-starting-popup__closeButton___LjZNu"};